// deadline-rate-limit-cap.ts — review 261006 (D1) M3b.
//
// A deadline kill classified `rate_limit` (deadline-rate-limit-signal.ts)
// goes to quota-sleep, which counts toward NO ceiling. A ticket that hangs
// after every 429 would otherwise loop forever: one full deadline of session
// time, a backoff sleep, again. So at most MAX_CONSECUTIVE_DEADLINE_RATE_LIMITS
// such classifications in a row per ticket; from the next one on — until the
// ticket has an attempt that did not end at the deadline — each is routed
// exactly like any other deadline kill (counted timeout ⇒
// split_after_timeouts ⇒ escalate). The streak is persisted in
// attempt-state.json (supervisor-attempt-state.ts) next to the retry counters.
import type { AttemptCycleResult } from "./supervisor-attempt-cycle.js";

export const MAX_CONSECUTIVE_DEADLINE_RATE_LIMITS = 3;

/** A deadline kill that session-runner classified as "still waiting on a rate limit". */
export function isDeadlineRateLimitCycle(cycle: AttemptCycleResult): boolean {
  return (
    cycle.kind === "verified" &&
    cycle.sessionResult.outcome === "deadline_exceeded" &&
    cycle.sessionResult.category === "rate_limit"
  );
}

/** Past the cap ⇒ the same cycle without its `rate_limit` category (plain timeout). */
export function demoteDeadlineRateLimitPastCap(
  cycle: AttemptCycleResult,
  priorStreak: number,
): AttemptCycleResult {
  if (cycle.kind !== "verified" || !isDeadlineRateLimitCycle(cycle)) return cycle;
  if (priorStreak < MAX_CONSECUTIVE_DEADLINE_RATE_LIMITS) return cycle;
  const { category: _rateLimit, ...sessionResult } = cycle.sessionResult;
  return {
    ...cycle,
    sessionResult: {
      ...sessionResult,
      reason:
        `deadline_ms_exceeded (rate-limit lúc deadline lần ${priorStreak + 1} liên tiếp, ` +
        `quá trần ${MAX_CONSECUTIVE_DEADLINE_RATE_LIMITS} — tính như timeout)`,
    },
  };
}
